<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-10-31 17:55:03
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-02-27 15:12:49
 * @FilePath: \vue-hepha-order\src\views\base\OrderSource.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="priceContainer">
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form
                    :form="queryForm"
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
                <span class="openBtn" v-if="!showForm" @click="showFormPanel(true)">
                    <icon-down-circle size="14"/>
                    {{ $t('base.open') }}
                </span>
                <span class="openBtn" v-else @click="showFormPanel(false)">
                    <icon-up-circle size="14" />
                    {{ $t('base.close') }}
                </span>
            </div>
        </div>
        
        
        <Table
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
        >
            <template v-slot:columns="{ props }">
                <div v-if="props.column.key == 'type'">
                    <a-tag :color="props.record.type_val == 0? 'blue' : 'green' ">{{ props.record.type }}</a-tag>
                </div>
                <div v-if="props.column.key == 'sign_type'">
                    <a-tag :color="props.record.sign_type_val == 1? 'blue' : 'red' ">{{ props.record.sign_type }}</a-tag>
                </div>
                <div v-if="props.column.key == 'logistics'">
                    <div v-if="props.record.sign_type_val == 1">
                        <div style="font-size:13px;color:#666;">{{ $t('stock.logisticsType') }}: {{ props.record.logistic_type }}</div>
                        <div style="font-size:13px;color:#666;">{{ $t('stock.logisticsNo') }}: {{ props.record.logistic_no }}</div>
                    </div>
                    <div v-else>-</div>
                </div>
            </template>

            <template v-slot:operate>
                <a-button 
                    v-permission="'setting.financial.downloadSignTemplate'" 
                    size="mini" class="form_btn" type="primary" 
                    @click="handle('downloadSignTemplate')"
                >
                    <icon-download size="13" style="marginRight:5px;"/>
                    {{ $t('financial.downloadSignTemplate') }}
                </a-button>
                <a-divider direction="vertical" v-permission="'setting.financial.downloadSignTemplate'" />
                <a-button 
                    v-permission="'setting.financial.importData'" 
                    size="mini" class="form_btn" type="primary" 
                    @click="handle('importData')"
                >
                    <icon-upload size="13" style="marginRight:5px;"/>
                    {{ $t('financial.importData') }}
                </a-button>
            </template>
        </Table>

        <!-- 弹窗 -->
        <a-modal
            v-model:visible="visible" 
            width="30%"
            :title="$t('financial.importData')"
            draggable
            :render-to-body="false"
            :mask-closable="false"
            :footer="null"
        >
            <a-upload 
                class="importFile" 
                :action="action"
                :headers="headers"
                :file-list="fileList" 
                :show-file-list="true" 
                :limit="1" 
                draggable 
                size="mini" 
                @success="(fileList)=>UploadSuccess(fileList)" 
                @error="(fileList)=>UploadError(fileList)" 
            ></a-upload>
        </a-modal>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, h } from 'vue';
    import { FinancialApi } from '@/api/FinancialApi.js'; 
    import { OrderApi } from '@/api/OrderApi.js';
    import { StockOutApi } from '@/api/StockOutApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { SignatureListQueryForm } from './queryConfig/FinancialQuery'
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';
    import { dateToTimestamp, timestampToDate, formatterToPoint, formatterToComma, getNowDate, getWeek } from '@/utils/index.js';

    const { t } = useI18n()
    const localeStore = useLocale()

    const queryForm = reactive(SignatureListQueryForm)
    const showForm = ref(false)
    const fileList = ref([])
    const action = ref(import.meta.env.VITE_BASE_URL + '/logistic/sign/import')
    const headers = ref({
        'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
    })
    console.log(action.value,'action')
    const visible = ref(false)
    const table = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:60,
                align:'center',
            },
            {
                // title: '订单名称',
                title:t('order.orderName'),
                dataIndex: 'order_name',
                key:'order_name',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:120,
            },
            {
                // title: '出库单号',
                title:t('stock.deliveryNumber'),
                dataIndex: 'mes_number',
                key:'mes_number',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:180,
            },
            {
                // title: 'sku',
                title:t('order.sku'),
                dataIndex: 'sku',
                key:'sku',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:120,
            },
            {
                // title: '订单类型',
                title:t('order.orderChannelType'),
                dataIndex: 'type',
                key:'type',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:120,
                slotName:'slot',
            },
            {
                // title: '签收类型',
                title:t('financial.signType'),
                dataIndex: 'sign_type',
                key:'sign_type',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:120,
                slotName:'slot',
            },
            {
                // title: '物流公司',
                title:t('stock.logistics'),
                dataIndex: 'logistics',
                key:'logistics',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:120,
                slotName:'slot',
            },
            {
                // title: '数量',
                title:t('order.quantity'),
                dataIndex: 'quantity',
                key:'quantity',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:90,
            },  
            {
                // title: '签收日期',
                title:t('financial.signDate'),
                dataIndex: 'sign_date',
                key:'sign_date',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:120
            },
            {
                // title: '创建日期',
                title:t('order.createDate'),
                dataIndex: 'create_date',
                key:'create_date',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:120
            },
            {
                // title: '创建人',
                title:t('order.createUser'),
                dataIndex: 'create_user',
                key:'create_user',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:120
            },
        ],
        configs:{
            scroll:{
                // x:1000,
                y:480,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })

    const handle = (type,row)=>{
        switch(type){
            case 'search':
                table.value.configs.pagination.current = 1
                getSignatureList()
                break;
            case 'reset':
                for(let key in queryForm.formData){
                    queryForm.formData[key] = ''
                }
                queryForm.formData.sign_type = 1
                table.value.configs.pagination.current = 1
                getSignatureList()
                break;
            case 'downloadSignTemplate':
                downloadSignTemplate()
                break;
            case 'importData':
                visible.value = true
                fileList.value = []
                break;
        }
    }

    const showFormPanel = (val)=>{
        showForm.value = val
    }

    const handlePressEnter = (val,item)=>{
        // console.log(val,item,'vvbnn')
        table.value.configs.pagination.current = 1
        getSignatureList()
    }

    const handleInputClear = (val,item)=>{
        // console.log(val,item,'vvbnn2222')
        table.value.configs.pagination.current = 1
        getSignatureList()
    }

    const search = (val)=>{
        table.value.configs.pagination.current = 1
        getSignatureList()
    }

    const handleSelectChange = (val)=>{
        console.log(val,'vvvv')
        action.value = val == 1? import.meta.env.VITE_BASE_URL + '/logistic/sign/import' : import.meta.env.VITE_BASE_URL + '/logistic/sign/import/return'
        console.log(action.value,'action')

        table.value.configs.pagination.current = 1
        getSignatureList()
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getSignatureList()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getSignatureList()
    }

    // 获取列表
    const getSignatureList = async ()=>{
        let param = {
            ...queryForm.formData,
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true

        let res = await FinancialApi.getInstance().getSignatureList(param,page_num,page_size)
        if(res.code == 0){
            table.value.datas = []
            res.data.records.forEach((i,index)=>{
                table.value.datas.push({
                    ...i,
                    No:index + 1,
                    type_val:i.type,
                    type: i.type == 0? t('order.user') : t('order.dealer'),
                    sign_date: i.sign_date == undefined? '-' : timestampToDate(i.sign_date * 1000).split(' ')[0],
                    sign_type_val: i.sign_type,
                    sign_type: i.sign_type == 1? t('financial.shipSign') : t('financial.returnSign'),
                })
            })
            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 下载发货签收模板
    const downloadSignTemplate = async()=>{
        let res = queryForm.formData.sign_type == 1
                ? await FinancialApi.getInstance().downloadSignTemplate()
                : await FinancialApi.getInstance().downloadReturnSignTemplate()

        if(!res.code){
            let blob = new Blob([res])
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = queryForm.formData.sign_type == 1? `${t('financial.shipSignTemplates')}.xlsx` : `${t('financial.returnSignTemplates')}.xlsx`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            Message.success(t('base.downloadSuccess'))
        }else{
            Message.error(res.msg)
        }
    }

    // 上传成功回调 
    const UploadSuccess = (res) => {
        console.log(res,'success')
        fileList.value.push(res.file) 
        Message.success(t('plan.importSuccess'))
        visible.value = false
        table.value.configs.pagination.current = 1
        getSignatureList()
    }

    // 上传失败回调
    const UploadError= (res) => {
        console.log(res,'error')
        if(res.response.code == 1003){
            let msg = res.response.msg.replaceAll(';',' ')
            Modal.error({
                title: t('base.error'),
                titleAlign:'start',
                content: ()=> h('pre',{},msg),
                width:900,
                hideCancel:true,
                okText:t('base.ok'),
                onOk:()=>{}
            });
        }else{  
            Message.error(t('plan.importFail') + res.response.msg)
        }
    }

    // 获取产品列表,拿到SKU下拉数据
    const getSku = async ()=>{
        let res = await OrderApi.getInstance().getProductList({simple_flag:1})
        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'sku')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label:i.sku,
                    value:i.sku,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取物流公司
    const getCourierType = async ()=>{
        let res = await StockOutApi.getInstance().getCourierType({dict_code: "courier"})
        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'logistic_type')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label:i.dict_sub_name,
                    value:i.dict_sub_value,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 处理查询面板伸缩时表格高度
    const resetTableHeight = (clientHeight)=>{
        const headerHeight = document.querySelector('.arco-layout-header').clientHeight
        const breadcrumbHeight = document.querySelector('.arco-page-header-with-breadcrumb').clientHeight
        const searchContentDomHeight = document.querySelector('.queryPanel').clientHeight
        const pageHeight = 50
        const footerHeight = document.querySelector('.footer').clientHeight
        table.value.configs.scroll.y = clientHeight - headerHeight - breadcrumbHeight - searchContentDomHeight - pageHeight - footerHeight - 100
    }

    watch(localeStore,(val)=>{
        resetTableHeight(val.clientHeight)
    })

    onMounted(async()=>{
        queryForm.formData.sign_type = 1

        getSku()
        getCourierType()
        getSignatureList()

        nextTick(()=>{
            const clientHeight = document.body.clientHeight
            resetTableHeight(clientHeight)
        })
    })
</script>

<style lang="less" scoped>
.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:14;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        flex:1;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left:1px solid #eee;
        padding-left:5px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    /deep/ .arco-form-item-layout-inline{
        margin-right: 0;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

.alertBar{
    display: inline-block;
    width: fit-content;
    font-size:12px;
    font-weight: 600;
}

/deep/ .arco-alert{
    padding: 1px 15px;
    vertical-align: bottom;

    .arco-alert-icon,
    .arco-alert-body{
        display: inline-block;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}

/deep/ .arco-modal-body{
    text-align: center !important;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    padding: 3px 0;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/ .arco-input-wrapper .arco-input[disabled] {
    -webkit-text-fill-color: #999;
}

/deep/ .arco-form-item-label-col{
    width:0 !important;
}

/deep/ button:focus, button:focus-visible{
    outline:none;
}
</style>